<template>
	<div v-if="showSurvey" :class="buttonClass" @click="handleSurvey">
		<!-- PC版本 -->
		<template v-if="mode === 'pc'">
			<SvgIcons name="icon_survey" class="c-action-svg" />
			<span class="action-block-span">{{ getModuleName('appointment') }}</span>
		</template>

		<!-- 移动端版本 -->
		<template v-else>
			<SvgIcons name="icon_survey" class="mobile-action-svg" />
		</template>

		<CTeleport to="#app">
			<!-- PC端弹窗 -->
			<CDialogSurvey v-if="mode === 'pc'" :visible.sync="visibleSurvey" />
		</CTeleport>
	</div>
</template>

<script setup>
import { computed, ref, inject } from 'vue';
import { useCommonData } from '@/hooks';
import { useModuleDisplay } from '../hooks/useModuleDisplay.js';
import { useStore } from '@/utils/vue-api';
import { debounce } from '@/utils/api';
import CDialogSurvey from '@/rebuild/materials/shared/appointment/LaoPuCDialogSurvey.vue'

const mode = inject('mode');
const buttonClass = inject('roundButtonClass');

const { getSurveyEntry, getModuleName, trackAction } = useModuleDisplay();

const store = useStore();
const isCalendar = computed(() => store.state.activeModuleId == 'customs_calendar');

const showSurvey = computed(() => {
	if (mode === 'pc') return getSurveyEntry.value;
	if (isCalendar.value) return false; // 移动端视图，日历页面存在其他入口按钮，需要隐藏这边的悬浮按钮
	return getSurveyEntry.value;
});

// 弹窗状态
const visibleSurvey = ref(false);

const { generateMobileModuleUrl } = useCommonData();

// 点击处理
const handleSurvey = debounce(
	() => {
		trackAction('survey');

		if (mode === 'mobile') {
			// 移动端跳转
			const surveyUrl = generateMobileModuleUrl('appointment', { f: 'PC' });
			window.open(surveyUrl, '_blank');
		} else {
			// PC端显示弹窗
			visibleSurvey.value = true;
		}
	},
	200,
	true
);
</script>
